module.exports = __webpack_public_path__ + "static/media/Thomas.981a6934.png";